import styles from './OrderRatingForm.module.css'
import { DetailsRow } from 'components/Shared/CrudComponents'
import { ReadonlyRatingFieldComponent } from './RatingFieldComponent'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContainedButton } from 'components/Shared/ContainedButton'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'

export function ReadonlyOrderRating ({ values, onClose, fields }) {
  const { t } = useTranslation()

  return (
    <div className={styles.ratingDetails}>
      <div>
        {fields.map((field) => (
          values?.[field.name] &&
            <DetailsRow key={field.name}>
              <ReadonlyRatingFieldComponent
                value={values[field.name].value}
                label={t(field.label)}/>
              <ReadOnlyTextField
                value={values[field.name].comment}
                label={t('orderRatingView.comment')}
                className={styles.ratingComment}
                multiline/>
            </DetailsRow>
        ))}
      </div>
      <ContainedButton
        onClick={onClose}
        className={styles.button}
        label={t('orderRatingView.close')}
      />
    </div>
  )
}
